module.exports = __webpack_public_path__ + "static/media/hero_3_computer.1790830a.mp4";